<template>
  <div class="main-content-container container-fluid px-4">
    <div class="d-flex page-header row no-gutters pt-4 pb-2">
      <div
        class="col-12 pl-sm-12 pl-0 col-12 col-sm-12 col-md-12 text-center text-sm-left mb-sm-0 mb-3"
      >
        <div class="pb-2">
          <span class="pl-sm-1 pl-0 text-uppercase page-subtitle">
            {{ $t("dailyReport.topHeader") }}
          </span>
        </div>
        <div class="main-heading">
          <h3 class="page-title, x">
            {{ $t("dailyReport.manager.review") }}
          </h3>
        </div>
      </div>
    </div>
    <div class="grid-main">
      <div class="grid-iner">
        <div class="ml-md-3 mr-md-3 form-group search-icon">
          <span class="search-icon-item">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
          <input
            class="form-control pl-5"
            :placeholder="$t('dailyReport.user.search')"
            v-model="searchTerm"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="users-list">
      <div
        v-for="(user, index) in filteredUsers"
        :key="index"
        class="ml-md-3 form-group form-field-style-5"
      >
        <button
          :class="{
            'selected-user-btn': selectedUser === user.reference,
            'user-btn': selectedUser !== user.reference
          }"
          @click="selectUser(index)"
        >
          {{ user.firstName + " " + user.lastName }}
        </button>
      </div>
    </div>
    <!-- page header -->
    <!-- @FixMe: call it through shared components  -->
    <div v-show="selectedUser != ''">
      <VueCal
        :selected-date="picker"
        :time-from="0 * 60"
        :time-to="24 * 60"
        v-if="isMobile()"
        :disable-views="['years', 'year', 'month', 'week']"
        :events="events"
        class="vuecal--full-height-delete"
        locale="fr"
        @event-title-change="eventCreateAndEditHandler"
        @event-delete="eventDeleteHandler"
        @event-duration-change="eventResizing"
        :readOnly="false"
      >
        <template v-slot:title="{ title }">
          <v-dialog v-model="dialog" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black lighten-2"
                icon
                text
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>event</v-icon>
              </v-btn>
            </template>

            <v-date-picker
              locale="fr"
              color="#4f78e2"
              v-model="picker"
            ></v-date-picker>
          </v-dialog>
          {{ title }}
        </template>
      </VueCal>
      <VueCal
        v-else
        :selected-date="picker"
        :readOnly="true"
        :time-from="timeFrom * 60"
        :time-to="24 * 60"
        :disable-views="['years', 'year', 'month']"
        :events="events"
        class="vuecal--full-height-delete"
        locale="fr"
        :showWeekNumbers="true"
      >
        <template v-slot:title="{ title }">
          <v-dialog v-model="dialog" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black lighten-2"
                icon
                text
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>event</v-icon>
              </v-btn>
            </template>

            <v-date-picker
              locale="fr"
              color="#4f78e2"
              v-model="picker"
            ></v-date-picker>
          </v-dialog>
          {{ title }}
        </template>
      </VueCal>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { fr } from "vuejs-datepicker/dist/locale";
import VueCal from "vue-cal-custom";
import "vue-cal-custom/dist/vuecal.css";
import "vue-cal-custom/dist/i18n/fr.js";
import "./calendar.scss";

export default {
  async mounted() {
    this.currentUser = this.$store.state.user.informations;

    await this.fetchUsers();
  
  },
  created() {
    window.addEventListener("wheel", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("wheel", this.handleScroll);
  },
  data() {
    return {
      events: [],
      reports: [],
      dialog: false,
      picker: undefined,
      filteredReports: [],
      userName: "",
      structure: "",
      dateFor: "",
      dateAdded: "",
      type: ["day", "week"],
      fr,
      selectedUser: "",
      distinctUsers: [],
      searchTerm: "",
      selectedUsersReports: [],
      currentUser: {},
      usersList: [],
      timeFrom: 8
    };
  },
  components: { VueCal },
  computed: {
    selectedDate() {
      const now = Date.now();
      const date = new Date(now);
      return `${date.getFullYear()}-${Number(date.getMonth()) + 1}-${date.getDate()}`;
    },
    filteredUsers() {
      if (this.searchTerm === "") {
        return this.usersList;
      }
      const fullNames = this.usersList.map(user => ({
        fullName: user.firstName + user.lastName,
        reference: user.reference
      }));
      const filteredRefs = fullNames
        .filter(name =>
          name.fullName.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
        .map(item => item.reference);
      return this.usersList.filter(item =>
        filteredRefs.includes(item.reference)
      );
    },
    personalRoute() {
      return this.$route.path == "/personalTasks";
    }
  },

  methods: {
    handleScroll(event) {
      if (event.deltaY < 0) {
        if (this.timeFrom > 0) this.timeFrom -= 1;
      } else if (event.deltaY > 0) {
        if (this.timeFrom < 8) this.timeFrom += 1;
      }
    },
    fetchReports(reference) {
      this.$services.dailyReport.getReportsByUserRef(reference).then(res => {
        this.reports = res.data;

        this.filteredReports = this.reports;
      });
    },
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    selectUser(index) {
      if (this.selectedUser === this.usersList[index].reference) {
        this.selectedUser = "";
      } else {
        this.selectedUser = this.usersList[index].reference;
      }
    },
    fetchUsers() {
      const userId = this.currentUser.reference;
      let flag = this.personalRoute; // flag to determine in case of manager (all users or subordinates)
      if (this.currentUser.permissions[0].groupReference == "_super_admin") {
        flag = true;
      }
          this.employee(`/employee/incharge/${userId}`, flag); // under manager
    },
    fillUserList(user, count) {
      this.usersList.push({
        value: `${count}`,
        label: `${user.firstName} ${user.lastName}`,
        reference: user.reference,
        firstName: user.firstName,
        lastName: user.lastName,
        groupReference: this.setUserGroupRefernce(user)
      });
      this.$store.dispatch("employeeForTask", this.usersList);
    },
    employee(url, flag) {
      let count = 0;
      this.$services.user.employeeForParticularGroup(url, flag).then(res => {
        res.data.forEach(user => {
          this.fillUserList(user, count);
          count++;
        });
      });
    },
    setUserGroupRefernce(user) {
      const groupReferences = [];
      user.permissions.forEach(p => {
        groupReferences.push(p.groupReference);
      });
      return groupReferences;
    }
  },
  watch: {

    selectedUser(newVal, oldVal) {
      const d=new Date()
      this.picker=this.selectedDate
      if (newVal === "") {
        this.events = [];
        return;
      }
      if (newVal === oldVal) return;
      const user = this.usersList.find(
        item => item.reference === this.selectedUser
      );
      const { reference } = user;
      this.fetchReports(reference)

    },
    filteredReports(){
     this.selectedUsersReports = this.filteredReports;

    },
    selectedUsersReports() {

      const eventsPerReport = this.selectedUsersReports.map(report => {
        const date = report.report.dateOfReport;
        const tasks = report.report.tasks ? report.report.tasks : [];
        const d = new Date(report.report.dateOfReport);
        const eventsPerTask = tasks.map(task => {
          const { startHour, endHour } = task;
          const start_hour = Number(startHour.hour);
          const end_hour = Number(endHour.hour);

          const start_mint = Number(startHour.mint);
          const end_mint = Number(endHour.mint);
          d.setHours(start_hour);
          d.setMinutes(start_mint);
          const startDate = new Date(d.getTime());
          d.setHours(end_hour);
          d.setMinutes(end_mint);
          const endDate = new Date(d.getTime());
          const duration = {
            hour: `${Math.abs(endDate.getHours() - startDate.getHours())}`,
            mint: `${Math.abs(endDate.getMinutes() - startDate.getMinutes())}`
          };
          return {
            start: `${startDate.getFullYear()}-${startDate.getMonth() +
              1}-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}`,
            end: `${endDate.getFullYear()}-${endDate.getMonth() +
              1}-${endDate.getDate()} ${endDate.getHours()}:${endDate.getMinutes()}`,
            content: task.title,
            class: "blue-event",
            title: `${
              Number(duration.hour) < 10
                ? `0${Number(duration.hour)}`
                : Number(duration.hour)
            }h ${
              Number(duration.mint) < 10
                ? `0${Number(duration.mint)}`
                : Number(duration.mint)
            }m`
          };
        });
        return eventsPerTask;
      });
      let events = [];
      eventsPerReport.forEach(event => {
        events = [...events, ...event];
      });

      this.events = events;
    },
    type: [
      {
        handler: "selectApi"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
.grid-main {
  display: grid;
  grid-template-columns: 60% 40%;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 100%;
  }
}
.grid-iner {
  display: grid;
  grid-template-columns: 80%;
  grid-gap: 0px;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 70% 30%;
    grid-gap: 5px;
  }
}

.main-heading {
  object-fit: contain;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.34;
  letter-spacing: normal;
  text-align: left;
  color: #212529;
  font-family: "SF-Pro-Text";
}

.only-sm-mobile {
  display: none;
}
@media screen and (min-width: 320px) and (max-width: 1196px) {
  .only-desk-top {
    display: none;
  }
  .only-sm-mobile {
    display: block;
    .apply {
      float: left;
    }
  }
}

.form-control {
  background-color: #fff !important;
}
.form-field-style-5 {
  width: 131px;

  .user-btn {
    background-color: #e0e3ed;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 40px;
    color: #9b9fb7;
    font-family: "SF-Pro-Text";
    font-weight: 600;
    &:focus {
      outline: none;
    }
  }
  .selected-user-btn {
    background-color: #cedaf8;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 40px;
    color: #4f78e1;
    font-family: "SF-Pro-Text";
    font-weight: 600;
    &:focus {
      outline: none;
    }
  }
}
.users-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
